import React, { useEffect, useState } from "react";
import { ArrowLeft, Trophy, Skull, Users, RefreshCw } from "lucide-react";
import { fetchLeaderboardTop, fetchTodayStats } from "../game/leaderboardService";
import { playClick } from "../game/sound";
import PlayerBadge from "../components/PlayerBadge";

const LEVEL_NAMES = {
  1: "Backyard",
  2: "Park",
  3: "Suburbs",
  4: "Downtown",
  5: "City Center",
};

export default function Leaderboard({ onBack }) {
  const [entries, setEntries] = useState(null);
  const [today, setToday] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const [list, stats] = await Promise.all([
      fetchLeaderboardTop(10),
      fetchTodayStats(),
    ]);
    setEntries(list);
    setToday(stats);
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  const handleRefresh = () => {
    playClick();
    load();
  };

  return (
    <div className="screen leaderboard-screen" data-testid="leaderboard-screen">
      <button
        type="button"
        className="zc-btn icon-back"
        onClick={() => {
          playClick();
          onBack();
        }}
        data-testid="leaderboard-back-button"
      >
        <ArrowLeft size={18} /> Back
      </button>

      <div className="lb-wrap">
        <h1 className="lb-title">
          <Trophy size={28} /> Leaderboard
        </h1>

        <div className="lb-today">
          <div className="lb-today-item" data-testid="lb-today-zombies">
            <Skull size={18} />
            <div>
              <div className="lb-today-value">{today ? today.zombies.toLocaleString() : "—"}</div>
              <div className="lb-today-label">zombies today</div>
            </div>
          </div>
          <div className="lb-today-item" data-testid="lb-today-runs">
            <Users size={18} />
            <div>
              <div className="lb-today-value">{today ? today.runs.toLocaleString() : "—"}</div>
              <div className="lb-today-label">runs today</div>
            </div>
          </div>
          <button
            type="button"
            className="zc-btn lb-refresh"
            onClick={handleRefresh}
            aria-label="Refresh"
            data-testid="leaderboard-refresh-button"
          >
            <RefreshCw size={16} />
          </button>
        </div>

        <div className="lb-table" data-testid="lb-table">
          <div className="lb-row lb-header">
            <span className="lb-rank">#</span>
            <span className="lb-name">Player</span>
            <span className="lb-wave">Wave</span>
            <span className="lb-score">Score</span>
            <span className="lb-level">Level</span>
          </div>
          {loading && <div className="lb-empty">Loading…</div>}
          {!loading && entries && entries.length === 0 && (
            <div className="lb-empty">No runs yet. Be the first!</div>
          )}
          {!loading &&
            entries &&
            entries.map((e, i) => (
              <div
                key={e.id}
                className={`lb-row ${i < 3 ? `lb-rank-${i + 1}` : ""}`}
                data-testid={`lb-row-${i + 1}`}
              >
                <span className="lb-rank">{i + 1}</span>
                <span className="lb-name">
                  {e.name}
                  <PlayerBadge isFounder={e.is_founder} isVip={e.is_vip} />
                </span>
                <span className="lb-wave">{e.wave}</span>
                <span className="lb-score">{e.score.toLocaleString()}</span>
                <span className="lb-level">{LEVEL_NAMES[e.level_id] || `Lv ${e.level_id}`}</span>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
